<template>
  <div class="home">
    <v-card width="50%" class="mx-auto mt-15">
      <v-form>
        <v-text-field class="mx-5" v-model="name" label="Name"></v-text-field>
      </v-form>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn width="100%" @click="gotomenu">Create Game</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
// @ is an alias to /src

// TODO - https://vuetifyjs.com/en/components/tabs/
export default {
  name: "Home",
  methods: {
    gotomenu() {
      this.$router.push({
        name: "CreateMenu",
        params: {
          playerName: this.name,
        },
      });
    },
  },
  data() {
    return {
      name: "",
    };
  },
};
</script>
